<template>
    <div class="v-result">
        <slot name="icon">
            <v-icon v-if="icon" :name="icon" :style="{ width: 160, height: 160, ...iconStyle }"></v-icon>
        </slot>
        <slot name="title" class="v-result-title">
            <p v-if="title" :style="{ 'margin-top': '40px', ...titleStyle }" class="v-result-title">{{ title }}</p>
        </slot>
        <slot name="subTitle" class="v-result-sub-title">
            <p v-if="subTitle" class="v-result-sub-title">{{ subTitle }}</p>
        </slot>
        <slot name="buttonText">
            <v-button v-if="buttonText" status="primary" size="large" @click="handleClick">{{ buttonText }}</v-button>
        </slot>
        <slot name="describe" class="v-result-describe">
            <p v-if="describe" class="v-result-describe">{{ describe }}</p>
        </slot>
        <slot name="more"></slot>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';

const req = require.context('@/assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
    name: 'Result',
    props: {
        // ICON配置
        icon: {
            type: String,
            default: ''
        },
        iconStyle: {
            type: Object,
            default: () => {}
        },

        // 标题样式
        titleStyle: {
            type: Object,
            default: () => {}
        },

        // 主副标题
        title: {
            type: String,
            default: ''
        },
        subTitle: {
            type: String,
            default: ''
        },
        describe: {
            type: String,
            default: ''
        },

        // 按钮文字
        buttonText: {
            type: String,
            default: ''
        }
    },
    data() {
        return {};
    },
    created() {},
    methods: {
        // 点击默认操作按钮
        handleClick() {
            this.$emit('click');
        }
    }
};
</script>

<style lang="less">
@import './style.less';
</style>
